module.exports = __webpack_public_path__ + "assets/lazypay.851b9a003656f4376d3a96df77601cf5.svg";